import axios from 'axios';

import { useEffect } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { useAuth } from '@/providers/AuthProvider/AuthProvider';
import { API_URL } from '@/lib/apiUrl';

export const useApi = () => {
  const { userData } = useAuth();
  const navigate = useNavigate();

  const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true, // ✅ Ensures cookies are sent
  });

  useEffect(() => {
    // Add interceptors after the axios instance is created
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response, // Pass through successful responses
      (error) => {
        if (error.response?.status === 401) {
          const errorMessage = error.response?.data?.error;
          if (errorMessage === 'Please login to continue') {
            navigate({
              to: '/experiences/login',
              search: { error: 'login-to-continue' },
            });
          }
        }

        if (error.response?.status === 422) {
          const errorMessage = error.response?.data?.error;
          if (errorMessage === 'You need to finish creating your company before proceeding.') {
            navigate({
              to: '/experiences/signup',
              search: {
                email: userData?.email ?? undefined,
                registrationContext: undefined,
                returnUrl: undefined,
              },
            });
          }
        }
        return Promise.reject(error); // Reject the promise for other errors
      }
    );

    return () => {
      axiosInstance.interceptors.response.eject(interceptor);
    };
  }, [axiosInstance, navigate, userData]);

  return { axiosInstance };
};

export default useApi;
